export const COLLAPSED = 1
export const OPEN = 2
export const EXPANDED = 3

export const STATUS_MAP = {
  [COLLAPSED]: { collapsed: true, open: false, expanded: false },
  [OPEN]: { collapsed: false, open: true, expanded: false },
  [EXPANDED]: { collapsed: false, open: false, expanded: true }
}

export const extractStatuses = status => STATUS_MAP[status]



// WEBPACK FOOTER //
// ./src/constants/editorPanelStatuses.js